import { Component } from '@angular/core';
import { AuthService } from '@core/guards/auth.service';
import { AuthenticationInfoService } from '../guards/authentication-info.service';
import { AccessRequirement } from '../models/access-requirement.model';
import { Subject, filter, takeUntil } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  isAuthenticated: boolean = true;
  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private authService: AuthService,
    private authenticationInfoService: AuthenticationInfoService
  ) {
    this.authenticationInfoService.userProfileLoaded$
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((userProfile) => !_.isNil(userProfile))
      )
      .subscribe(() => {
        this.isAuthenticated = !!(authService.currentUser);
      }
      );
  }

  get name() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.name_simple
      : '';
  }

  get name_initial() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.name_initial
      : '';
  }

  get showMenu() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasAnyGrantAccess
      : false;
  }

  get showControl() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.ControlNotPPRMembership
        )
      : false;
  }

  get showDispatched() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.OperationalMembership
        )
      : false;
  }

  get showRejected() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.SupervisionMembership
        )
      : false;
  }

  get showDirect() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.SupervisionMembership
        )
      : false;
  }

  get showLate() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.SupervisionMembership
        )
      : false;
  }

  get showInvoicesSearch() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasAnyGrantAccessForInvoices()
      : false;
  }

  get showVoucherWorkflow() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.ValidationMembership
        )
      : false;
  }

  get showPromotionWorkflow() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.PPRValidationMembership
        )
      : false;
  }

  get showVoucherValidated() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.NonErpMemberShip
        )
      : false;
  }

  get showAnalysis() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.AnalyticalMembership
        )
      : false;
  }

  get showAdministration() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.AdministrationMembership
        )
      : false;
  }

  get showWaitingVoucher() {
    return this.authenticationInfoService.authentificatedUser
      ? this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.ControlMembership
        ) ||
        this.authenticationInfoService.authentificatedUser.hasGrant(
          AccessRequirement.ControlNotPPRMembership
        ) ||
          this.authenticationInfoService.authentificatedUser.hasGrant(
            AccessRequirement.OperationalMembership
          ) ||
          this.authenticationInfoService.authentificatedUser.hasGrant(
            AccessRequirement.OperationContributorMembership
          )
      : false;
  }

  logout() {
    this.authService.logout();
  }
}
